<template>
    <List
        :form="form"
    />
</template>

<script>
import List from '@/components/almoxarifado/dispensacao-materiais/components/historico/List'

export default {
    components: {
        List
    },
    props: {
        form: { type: Object, default: null }
    }
}
</script>